module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"current_reward":"Current Reward","remaining_reward":"Remaining Reward Limit"}}')
  delete Component.options._Ctor
}
